
export default [
  {
    path: '/admin/coa-setups',
    name: 'coa-setup',
    meta: { requiresAuth: true },
    component: () => import('@/pages/accounting/coa-setup')
  }
]
